import { render, staticRenderFns } from "./refreshPassword.vue?vue&type=template&id=55a3b50a"
import script from "./refreshPassword.vue?vue&type=script&lang=js"
export * from "./refreshPassword.vue?vue&type=script&lang=js"
import style0 from "./refreshPassword.vue?vue&type=style&index=0&id=55a3b50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports